import React from "react";
import { Redirect } from "react-router-dom";
import imagen from "../components/generalComponents/images/logoBPW.png";
import NavbarBpw2 from "../components/generalComponents/NavbarBpw2";

const AdminEmpresa = () => {
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);
	return (
		<div>
			{localUser.type === "2" ? (
				<div>
					<NavbarBpw2 />
					<div className="containerIcon">
						<h2>B I E N V E N I D O</h2>
						<br />
						<br />
						<br />
						<img src={imagen} />
					</div>
				</div>
			) : (
				<Redirect to="/intruso" />
			)}
		</div>
	);
};

export default AdminEmpresa;
